function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import EBPropTypes from 'js-utils/prop-types';
import classNames from 'classnames';
import Graphic from '../graphic/Graphic';
import { GRAPHIC_TYPE_PROP_TYPE } from '../graphic/constants';
import Button from '../button/Button';
import * as constants from './constants';
import { classRange } from '../utils/general';

var Title = function Title(_ref) {
  var children = _ref.children,
      isDisabled = _ref.isDisabled;
  var component = null;

  if (children) {
    var responsiveMargin = "".concat(classRange('mar-top-6', 'sn', 'md'), " ").concat(classRange('mar-top-8', 'md'));
    var className = classNames('eds-empty-state__title', 'eds-text--center', 'eds-text-hs', {
      'eds-text-color--grey-900': !isDisabled,
      'eds-text-color--grey-500': isDisabled
    }, responsiveMargin);
    component = React.createElement("h1", {
      className: className
    }, children);
  }

  return component;
};

var Description = function Description(_ref2) {
  var children = _ref2.children,
      hasTitle = _ref2.hasTitle,
      isDisabled = _ref2.isDisabled;
  var component = null;

  if (children) {
    var _classNames;

    var responsiveMargin = "".concat(classRange('mar-top-3', 'sn', 'md'), " ").concat(classRange('mar-top-1', 'md'));
    var responsiveMarginNoTitle = "".concat(classRange('mar-top-6', 'sn', 'md'), " ").concat(classRange('mar-top-8', 'md'));
    var className = classNames('eds-empty-state__description', 'eds-text--center', 'eds-text-bl', (_classNames = {
      'eds-text-color--grey-600': !isDisabled,
      'eds-text-color--grey-400': isDisabled
    }, _defineProperty(_classNames, responsiveMargin, hasTitle), _defineProperty(_classNames, responsiveMarginNoTitle, !hasTitle), _classNames));
    component = React.createElement("div", {
      className: "eds-align--center"
    }, React.createElement("p", {
      className: className
    }, children));
  }

  return component;
};

var Actions = function Actions(_ref3) {
  var primaryType = _ref3.primaryType,
      primaryText = _ref3.primaryText,
      onPrimaryAction = _ref3.onPrimaryAction,
      isDisabled = _ref3.isDisabled;
  var component = null;

  if (primaryText) {
    var responsiveMargin = "".concat(classRange('mar-top-4', 'sn', 'md'), " ").concat(classRange('mar-top-6', 'md'));
    var className = classNames('eds-empty-state__actions', 'eds-align--center', responsiveMargin);
    component = React.createElement("div", {
      className: className
    }, React.createElement(Button, {
      onClick: onPrimaryAction,
      style: primaryType,
      "data-spec": "eds-empty-state__primary-button",
      disabled: isDisabled
    }, primaryText));
  }

  return component;
};

var EmptyState =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(EmptyState, _PureComponent);

  function EmptyState() {
    _classCallCheck(this, EmptyState);

    return _possibleConstructorReturn(this, _getPrototypeOf(EmptyState).apply(this, arguments));
  }

  _createClass(EmptyState, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          graphicType = _this$props.graphicType,
          description = _this$props.description,
          primaryType = _this$props.primaryType,
          primaryText = _this$props.primaryText,
          onPrimaryAction = _this$props.onPrimaryAction,
          disableCentering = _this$props.disableCentering,
          title = _this$props.title,
          isDisabled = _this$props.isDisabled;
      var className = classNames('eds-empty-state', {
        'eds-align--center': !disableCentering
      });
      return React.createElement("div", {
        className: className
      }, React.createElement("div", null, React.createElement("div", {
        className: "eds-empty-state__graphic eds-align--center"
      }, React.createElement(Graphic, {
        hasHalo: true,
        haloSize: "xsmall",
        type: graphicType,
        size: "small"
      })), React.createElement(Title, {
        isDisabled: isDisabled
      }, title), React.createElement(Description, {
        hasTitle: !!title,
        isDisabled: isDisabled
      }, description), React.createElement(Actions, {
        primaryType: primaryType,
        primaryText: primaryText,
        onPrimaryAction: onPrimaryAction,
        isDisabled: isDisabled
      })));
    }
  }]);

  return EmptyState;
}(PureComponent);

_defineProperty(EmptyState, "propTypes", {
  /**
   * Graphic to be displayed
  */
  graphicType: GRAPHIC_TYPE_PROP_TYPE,

  /**
   * Title text to be displayed under the graphic
  */
  title: PropTypes.node,

  /**
   * Description text to be displayed under the title
  */
  description: PropTypes.node,

  /**
   * The type of button that should be shown for primary button
  */
  primaryType: PropTypes.oneOf(constants.PRIMARY_TYPES),

  /**
   * The text that should be shown across the primary button
  */
  primaryText: EBPropTypes.translation,

  /**
   * The function that should be triggered on primary button click
  */
  onPrimaryAction: PropTypes.func,

  /**
   * Disables the centering of the empty state container
  */
  disableCentering: PropTypes.bool,

  /**
   * Disable Empty state
  */
  isDisabled: PropTypes.bool
});

_defineProperty(EmptyState, "defaultProps", {
  graphicType: constants.DEFAULT_GRAPHIC,
  primaryType: constants.DEFAULT_TYPE,
  isDisabled: false
});

export { EmptyState as default };